import { TableHeadDataProps } from '../../components/Table/TableHead';

export const planpatientTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Plan Name' },
  { id: 2, title: 'Frequency' },
  { id: 3, title: 'Count' },
  { id: 4, title: 'Assigned date' },
  { id: 5, title: 'Due date' },
  { id: 6, title: 'Used count' },
  { id: 7, title: 'Actions' },
  { id: 8, title: '' },
];
